import { createStandardAction } from 'typesafe-actions';

export const toggleProductCreate = createStandardAction(
  'LAYOUT_TOGGLE_PRODUCT_CREATE'
)<void>();
